import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import * as actions from '../../actions/lk';
import SetPassword from '../../components/lk/SetPassword';

const selector = formValueSelector('setPassword');

const mapStateToProps = (state) => {
  const values = selector(state, 'oldpassword', 'newpassword', 'newpassword_repeat');
  const { oldpassword, newpassword, newpassword_repeat } = values;
  return {
    oldpassword,
    newpassword,
    newpassword_repeat,
    doPasswordsMatch: newpassword === newpassword_repeat,
    passwordError: state.lk.passwordError,
  };
};

const mapDispatchToProps = dispatch => ({
  setPassword: values => dispatch(actions.setPassword(values)),
  setPasswordError: value => dispatch(actions.setPasswordError(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);
